module.exports = __webpack_public_path__ + "static/Business cards-2f59296a42513094b6104036b78697b4.jpg";